import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-file-upload',
    imports: [CommonModule, FormsModule, ReactiveFormsModule],
    templateUrl: './file-upload.component.html',
    styleUrl: './file-upload.component.css'
})
export class FileUploadComponent {
  @Input() fields: any;
  @Input() formGroup!: FormGroup;
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

  selectedFileName: any[] = [];
  isDragOver: boolean = false;

  openFilePicker(event?: Event) {
    if (event) event.stopPropagation(); // prevent dropZone click
    this.fileInput.nativeElement.click();
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      const fileName = file.name;
      const extension = fileName.split('.').pop() || '';

      this.selectedFileName.push({
        name: fileName,
        extension: extension,
      });
    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    this.isDragOver = true;
  }

  onDragLeave() {
    this.isDragOver = false;
  }

  onFileDrop(event: DragEvent) {
    event.preventDefault();
    this.isDragOver = false;

    const file = event.dataTransfer?.files[0];
    if (!file) return;

    const fileName = file.name;
    const extension = fileName.split('.').pop() || '';

    // assign dropped file into input
    const fileList = new DataTransfer();
    fileList.items.add(file);
    this.fileInput.nativeElement.files = fileList.files;

    this.selectedFileName.push({
      name: fileName,
      extension: extension,
    });
  }

  removeFile(index: number): void {
    this.selectedFileName.splice(index, 1);
  }

  // document-view.component.ts
  getFileIcon(fileName: string): string {
    const extension = fileName.split('.').pop()?.toLowerCase();

    const iconMap: { [key: string]: string } = {
      pdf: `assets/media/file-types/pdf.png`,
      doc: `assets/media/file-types/doc.png`,
      docx: `assets/media/file-types/doc.png`,
      xls: `assets/media/file-types/xls.png`,
      xlsx: `assets/media/file-types/xls.png`,
      ppt: `assets/media/file-types/ppt.png`,
      pptx: `assets/media/file-types/ppt.png`,
      jpg: `assets/media/file-types/img.png`,
      jpeg: `assets/media/file-types/img.png`,
      png: `assets/media/file-types/img.png`,
      gif: `assets/media/file-types/img.png`,
      txt: `assets/media/file-types/txt.png`,
      default: `assets/media/file-types/default.png`,
    };

    return iconMap[extension || ''] || iconMap['default'];
  }
}
